.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 2px var(--space-2);
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  font-size: var(--text-2xs);
  font-weight: var(--weight-medium);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  white-space: nowrap;
}

.neutral {
  background: var(--bg-inset);
  border-color: var(--border-default);
  color: var(--text-secondary);
}

.accent {
  background: var(--accent-subtle);
  border-color: var(--accent-border);
  color: var(--accent);
}

.signal {
  background: var(--signal-subtle);
  border-color: var(--signal);
  color: var(--signal);
}

.success {
  background: var(--success-subtle);
  color: var(--success);
  border-color: var(--success);
}

.warning {
  background: var(--warning-subtle);
  color: var(--warning);
  border-color: var(--warning);
}

.danger {
  background: var(--danger-subtle);
  color: var(--danger);
  border-color: var(--danger);
}

.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
}
